import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UtilMethods from "../../util/UtilMethods";

const EventsPanel = () => {
  const { t } = useTranslation("labels"); // 'events' is the namespace
  const navigate = useNavigate();

  const eventsPath = process.env.REACT_APP_EVENTS_SOURCE || 'source/events.json';
  const events = require(`../../${eventsPath}`);

  const handleButtonClick = (eventId) => {
    if (!eventId) {
      console.error("Invalid event ID");
      return;
    }
    navigate(`/retreat-registration/${eventId}?mode=E`);
  };

  const upcomingEvents = events.filter(event => new Date(event.start_date) > new Date());
  const firstTwoEvents = upcomingEvents.slice(0, 2);

  if (!events) return <p>{t("loadingEvents")}</p>;
  if (events.length === 0) return <p>{t("noEventsAvailable")}</p>;

  return (
    <div className="container pb-5">
      <div className="text-center mb-4">
        <h2 className="display-4">{t("upcomingEvents")}</h2>
      </div>

      <div className="row">
        <div className="col-12 col-md-4 mb-3 d-flex justify-content-center">
          <img
            className="img-fluid"
            src={`${process.env.PUBLIC_URL}/./images/AchanBlessing-1.png`}
            alt="image for events"
          />
        </div>
        <div className="col-12 col-md-8">
          <p align="justify">{t("eventDescription")}</p>

          <div className="mt-4">
            {firstTwoEvents.length > 0 ? (
              <table className="table_event table-striped w-100">
                <tbody>
                  {firstTwoEvents.map((event, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td className="w-35">
                          <b className="date-highlight">
                            {UtilMethods.formatDateDDMONYYY(event.start_date)}
                          </b>
                          {event.reg_type !== "NO" && UtilMethods.canRegister(event.reg_date, event.reg_end_date || event.start_date) && (
                            <div className="mt-2">
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => handleButtonClick(event.id)}
                              >
                                {t("register")}
                              </button>
                            </div>
                          )}
                        </td>
                        <td className="w-70">
                          <h5 className="mb-1">{event.name}</h5>
                          <ul className="list-unstyled mb-0">
                            <li>
                              <i className="fa fa-calendar" aria-hidden="true"></i>{" "}
                              {UtilMethods.formatDate(event.start_date)} {t("to")}{" "}
                              {UtilMethods.formatDate(event.end_date)} <br />
                            </li>
                            <li>{t("eventTime")}: {event.timings}</li>
                            <li>{event.short_description}</li>
                            {event.map && (
                              <li>
                                <a
                                  className="fa fa-location-arrow"
                                  href={event.map}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  : {event.location}
                                </a>
                              </li>
                            )}
                          </ul>
                        </td>
                      </tr>
                      {index < firstTwoEvents.length - 1 && <tr><td colSpan="2"><hr /></td></tr>}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>{t("noUpcomingEvents")}</p>
            )}
          </div>

          <div className="text-end mt-3">
            <a href="/events" className="btn btn-outline-primary">
              {t("viewMore")} <i className="bi bi-arrow-right-circle"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventsPanel;
